import { useSelector } from 'react-redux';
import { useMediaQuery } from '@mui/material';

import PlannerMode from 'pages/PlannerMode';
import NavigationHeader from 'pages/NavigationComponent';
import { getPlannerMode } from 'redux/PlannerModeSlice';

import PlanPageScenario from './PlanPageScenario';

const PlanPageScenarioIndex = () => {
  const mobileVersion: boolean = useMediaQuery('(max-width: 1024px)');
  const plannerMode = useSelector(getPlannerMode);
  return (
    <>
      {plannerMode && !mobileVersion ? (
        <>
          <NavigationHeader />
          <PlannerMode />
        </>
      ) : (
        <PlanPageScenario />
      )}
    </>
  );
};
export default PlanPageScenarioIndex;
